<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-right">
        <v-btn color="primary" depressed @click="updateAllMessageRead()"> Skrýt zobrazené </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card v-if="notifications.length" class="elevation-0 rounded-lg pa-0">
          <v-list class="pa-0">
            <template v-for="(item, index) in notifications">
              <v-list-item :key="index" class="pt-2 pb-1">
                <v-list-item-action>
                  <v-icon>mdi-email</v-icon>
                </v-list-item-action>
                <v-list-item-content class="pa-0">
                  <DateTime :datetime="item.createdAt" :single-line="true" class="pb-1" />
                  <span v-html="getMessageContent(item)"></span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon text @click="updateMessageRead(item.id)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="index < notifications.length - 1"
                :key="`${index}-divider`"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
        <v-card v-else class="elevation-0 rounded-lg pa-0">
          <v-card-text class="text-center"> Žádné nové upozornění </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import DateTime from '../../../components/DateTime'

export default {
  name: 'Notifications',
  components: { DateTime },
  data() {
    return {
      user: null,
      loading: false,
      notifications: [],
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true],
      },
      skeleton: {
        article: 'heading, paragraph@2',
      },
    }
  },
  created() {
    this.loadUserMessages()
  },
  methods: {
    ...mapActions({
      getMe: 'auth/me',
      searchMessageUsers: 'message/searchMessageUsers',
      updateMessageStatus: 'message/updateMessageStatus',
    }),
    loadUserMessages() {
      this.loading = true
      this.getMe()
        .then((response) => {
          this.user = response.data
        })
        .finally(() => {
          this.loadMessages(this.user.id)
        })
    },
    loadMessages(id) {
      this.loading = true
      let filterParams = this.$route.query
      filterParams['userId'] = id
      filterParams['statuses'] = ['NEW']
      filterParams['types'] = ['CLOSABLE']
      filterParams['origin'] = true
      const searchParams = {
        filterParams: filterParams,
        options: this.options,
      }
      this.searchMessageUsers(searchParams)
        .then((response) => {
          this.notifications = response.data.items
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateMessageRead(id) {
      this.loading = true
      this.updateMessageStatus({ id: id, status: 'READ' }).finally(() => {
        this.loading = false
        this.loadMessages(this.user.id)
      })
    },
    updateAllMessageRead() {
      this.$confirm('', {
        title: 'Skrýt všechny zobrazené notifikace?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.loading = true
          this.notifications.forEach((e, idx, array) => {
            this.updateMessageStatus({ id: e.id, status: 'READ' }).finally(() => {
              if (idx + 1 === array.length) {
                this.loadMessages(this.user.id)
              }
            })
          })
        }
      })
    },
    getMessageContent(item) {
      let content = item.message.content
      content = this.getMessageContentWithOrderLinks(content)
      content = this.getMessageContentWithCustomerLinks(content)
      return content
    },
    getMessageContentWithOrderLinks(content) {
      let position = content.search('#')
      if (position === -1) {
        return content
      }
      let start = content.substring(position)
      let id = start.substring(position, start.indexOf(' '))
      if (start.charAt(start.length - 1) === '.') {
        id = id.replace(/\./g, '')
      }
      return content.replace(
        id,
        `<a style='text-decoration:none' href='/orders/${id.substring(
          1
        )}/detail' target='_blank'>${id}</a>`
      )
    },
    getMessageContentWithCustomerLinks(content) {
      let position = content.search('@')
      if (position === -1) {
        return content
      }
      let start = content.substring(position)
      let id = start.substring(position, start.indexOf(' '))
      if (start.charAt(start.length - 1) === '.') {
        id = id.replace(/\./g, '')
      }
      return content.replace(
        id,
        `<a style='text-decoration:none' href="/customers/${id.substring(
          1
        )}/detail" target="_blank">${id}</a>`
      )
    },
  },
}
</script>

<style scoped></style>
